/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var SupportDarkBlue = function SupportDarkBlue(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Support icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['support--dark-blue-1', 'support--dark-blue-2', 'support--dark-blue-3', 'support--dark-blue-4', 'support--dark-blue-5', 'support--dark-blue-6', 'support--dark-blue-7', 'support--dark-blue-8', 'support--dark-blue-9', 'support--dark-blue-10', 'support--dark-blue-11'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 200"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-3'],
    x1: "66.98",
    x2: "66.98",
    y1: "5.67",
    y2: "200.03",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#f6f2ff",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".47",
    stopColor: "#bdccfe",
    stopOpacity: ".47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".81",
    stopColor: "#99b4fe",
    stopOpacity: ".81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8babfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8cacfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-4'],
    x1: "116.59",
    x2: "35.2",
    y1: "1826.57",
    y2: "1875.25",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".01",
    stopColor: "#545a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3a3b46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-5'],
    x1: "67.19",
    x2: "134",
    y1: "1834.3",
    y2: "1834.3",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#313437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#434251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-6'],
    x2: "67.24",
    y1: "1834.3",
    y2: "1834.3",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#28292d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3c3d40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-1'],
    x1: "26.04",
    x2: "58.35",
    y1: "129.2",
    y2: "91.18",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#324280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#908dd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-7'],
    x1: "23.67",
    x2: "53.6",
    y1: "1828.84",
    y2: "1896.07",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    xlinkHref: "#".concat(gradientIds['support--dark-blue-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-8'],
    x1: "24.44",
    x2: "56.75",
    y1: "127.84",
    y2: "89.82",
    xlinkHref: "#".concat(gradientIds['support--dark-blue-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-2'],
    x1: "48.35",
    x2: "48.35",
    y1: "1850.13",
    y2: "1875.77",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#e6e6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#f2f4f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-9'],
    x1: "53.37",
    x2: "53.37",
    y1: "1847.35",
    y2: "1872.99",
    xlinkHref: "#".concat(gradientIds['support--dark-blue-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-10'],
    x1: "58.43",
    x2: "58.43",
    y1: "1844.48",
    y2: "1870.12",
    xlinkHref: "#".concat(gradientIds['support--dark-blue-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['support--dark-blue-11'],
    x1: "63.45",
    x2: "63.45",
    y1: "1841.7",
    y2: "1867.34",
    xlinkHref: "#".concat(gradientIds['support--dark-blue-2'])
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-3'], ")"),
    d: "M66.76 102.24L134 141.17V0H0v141.17z",
    opacity: ".1",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-4'], ")"),
    d: "M0 141.07l66.77-38.93L134 141.07 67.24 180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-5'], ")"),
    d: "M134 141.07v4.9L67.19 184.9V180z",
    opacity: ".7",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-6'], ")"),
    d: "M67.24 180v4.9L0 146v-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    fillOpacity: ".3",
    d: "M67.19 184.9l-54.2-31.4L0 161.07 67.19 200l66.77-38.93-12.99-7.52-53.78 31.35z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: ".8"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-1'], ")"),
    d: "M32.4 135.18l-1-.63-.05-25 1.05.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-7'], ")"),
    d: "M63.89 91.64l.09 25-31.58 18.54v-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-8'], ")"),
    d: "M32.35 110.18l-1.05-.64 31.54-18.49 1 .59z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f4f8",
    d: "M48.83 122.16l-1-.64L79.31 103l1 .59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-2'], ")"),
    d: "M48.92 147.16l-1.05-.63-.09-25 1 .64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d6eb",
    d: "M80.36 103.62l.09 25-31.53 18.54-.09-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-9'], ")"),
    d: "M53.94 149.94l-1-.64-.09-25 1.05.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f4f8",
    d: "M53.85 124.94l-1.05-.64 31.53-18.49 1.09.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d6eb",
    d: "M85.42 106.4v25l-31.48 18.54-.09-25z",
    opacity: ".8",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-10'], ")"),
    d: "M59 152.81l-1-.64-.09-25 1 .64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f4f8",
    d: "M58.91 127.81l-1-.64 31.53-18.49 1.1.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d6eb",
    d: "M90.49 109.27v25L59 152.81l-.09-25z",
    opacity: ".8",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f4f8",
    d: "M64 130.58l-1.1-.63 31.58-18.49 1.05.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['support--dark-blue-11'], ")"),
    d: "M64 155.59l-1-.59-.09-25 1.1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d6eb",
    d: "M95.51 112.05v25L64 155.59v-25z",
    opacity: ".8",
    style: {
      isolation: 'isolate'
    }
  }));
};
SupportDarkBlue.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var SupportDarkBlue$1 = SupportDarkBlue;

export { SupportDarkBlue$1 as default };
